<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script setup lang="ts">
defineProps<{
  id?: string,
  label: string,
  optional?: boolean,
  marginless?: boolean,
  modelValue: string,
  showLabel?: boolean,
  focus?: boolean,
}>()

defineEmits(['update:modelValue'])
</script>

<template>
  <div :class="[marginless ? '' : 'mb-2']">
    <label :for="id" :class="[showLabel ? 'label' : 'sr-only']">{{ label }}</label>
    <input :id="id" v-focus="focus || false" :required="!optional" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" v-bind="$attrs"/>
  </div>
</template>

<style scoped lang="scss">
label {
  @apply block mb-0.5 font-bold text-xs;
  @apply text-gray-300 dark:text-gray-500;
}

input {
  @apply relative block w-full rounded-lg appearance-none px-3 py-2;
  @apply bg-white dark:bg-gray-700;
  @apply border border-gray-300 dark:border-gray-500;
  @apply text-gray-900 dark:text-gray-200;
  @apply placeholder-gray-300 dark:placeholder-gray-500;
  @apply focus:z-10 focus:border-primary-500 focus:outline-none;
}
</style>
